import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function InvView(props){
  const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000));
  const [invData, setinvData] = useState([]);
  const [ipinvData, setIpinvData] = useState([]);

  useEffect(() => {
    fetchData();
    fetchIpData();
    const intervalId = setInterval(fetchData, 15000); // Fetch data every 5 seconds
    return () => clearInterval(intervalId); // Cl
  }, [selectedDate]);

  function fetchData() {
  const formattedDate = selectedDate.toISOString().substring(0, 10);
  axios.get(baseUrl + 'inv-entry-view/' + formattedDate + '/')
    .then(response => {
      // Filter for status = 2
      const filteredData = response.data.filter(item => item.inv_status == 2);
      setinvData(filteredData);
    })
    .catch(error => console.log(error));
}

function fetchIpData() {
  const formattedDate = selectedDate.toISOString().substring(0, 10);
  axios.get(baseUrl + 'ip-inv-entry-view/' + formattedDate + '/')
    .then(response => {
      // Filter for status = 2
      const filteredData = response.data.filter(item => item.inv_status == 2);
      setIpinvData(filteredData);
    })
    .catch(error => console.log(error));
}


  const handleDateChange = (date) => {
    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    setSelectedDate(localDate);
  };

  return (
    <section className="container mt-4">
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
            <div className="col-sm-9 col-lg-10 controls">
              <DatePicker selected={selectedDate} onChange={handleDateChange} dateFormat="dd/MM/yyyy" />
            </div>
          </div>
        </div>
      </div>
         <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
            aria-hidden="true" style={{color: 'red'}}></i>  View OP Radiology Order History</h3>
        <div className="table-responsive">
         <table className="erp-table-modern">
          <thead>
            <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
               <th align="left">S.No</th>
               <th align="left">Patient ID</th>
               <th align="left">Patient</th>
               <th align="left">Particulars</th>
               <th align="left">Addedby</th>
               <th align="left">Request On</th>
               <th align="left">Action</th>
            </tr>
          </thead>
          {invData.map((row, index) =>
          <tbody>
          {row.inv_test.split(',').map((test, subIndex) => (
            <tr key={`${index}-${subIndex}`}>
              <td style={{border: "1px solid", borderColor: "#2194d9"}}>{index + subIndex + 1}</td>
              <td style={{border: "1px solid", borderColor: "#2194d9"}}>{row.pat.pat_id}</td>
              <td style={{border: "1px solid", borderColor: "#2194d9"}}>{row.pat.patient}</td>
              <td style={{border: "1px solid", borderColor: "#2194d9"}}>{test.trim()}</td>
              <td style={{border: "1px solid", borderColor: "#2194d9"}}>{row.addedby}</td>
              <td style={{border: "1px solid", borderColor: "#2194d9"}}>{row.add_date}
              <br></br>{row.add_time}</td>
              <td style={{border: "1px solid", borderColor: "#2194d9"}}>
              <Link to={`/inv-result-enter/${row.id}/${row.itest_id.split(',')[subIndex].trim()}`} className="btn btn-success">
              Dicom
              </Link>
              </td>

            </tr>
            ))}
            </tbody>
            )}
            </table>
            </div>
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
            aria-hidden="true" style={{color: 'red'}}></i>  View IP Radiology Order History</h3>
            <div className="table-responsive">
            <table className="erp-table-modern">
          <thead>
            <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
               <th align="left">S.No</th>
               <th align="left">Patient ID</th>
               <th align="left">Patient</th>
               <th align="left">Particulars</th>
               <th align="left">Addedby</th>
               <th align="left">Request On</th>
               <th align="left">Action</th>
            </tr>
          </thead>
          {ipinvData.map((row, index) =>
          <tbody>
          {row.inv_test.split(',').map((test, subIndex) => (
            <tr key={`${index}-${subIndex}`}>
              <td style={{border: "1px solid", borderColor: "#2194d9"}}>{index + subIndex + 1}</td>
              <td style={{border: "1px solid", borderColor: "#2194d9"}}>{row.pat.pat_id}</td>
              <td style={{border: "1px solid", borderColor: "#2194d9"}}>{row.pat.patient}</td>
              <td style={{border: "1px solid", borderColor: "#2194d9"}}>{test.trim()}</td>
              <td style={{border: "1px solid", borderColor: "#2194d9"}}>{row.addedby}</td>
              <td style={{border: "1px solid", borderColor: "#2194d9"}}>{row.add_date}
              <br></br>{row.add_time}</td>
              <td>
              <Link to={`/inv-result-enter/${row.id}/${row.itest_id.split(',')[subIndex].trim()}`} className="btn btn-success">
              View
              </Link>
              </td>
            </tr>
            ))}
            </tbody>
            )}
            </table>
            </div>
    </section>
  )
}

export default InvView;
